export default {
    percent: '%',
    kc: 'Eur',
    ccm: 'ccm',
    kg: 'kg'
};
